import { Loader } from '@rocketlane/ui';
import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';

interface TextViewerProps {
  url: string;
  fileType: string;
}

export const TextViewer: React.FC<TextViewerProps> = ({ url, fileType }) => {
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoading(true);
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error('Failed to fetch file content');
        }
        const text = await response.text();

        setContent(text);
      } catch (err) {
        setError(
          'Unable to load file content' +
            (err instanceof Error ? err.message : ''),
        );
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, [url]);

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          fontSize: '16px',
          color: '#666',
        }}
      >
        <Loader size={32} />
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          fontSize: '16px',
          color: '#ff4d4f',
        }}
      >
        {error}
      </div>
    );
  }

  if (fileType === 'markdown') {
    return (
      <div
        style={{
          height: '100%',
          overflow: 'auto',
          lineHeight: '1.6',
          fontSize: '14px',
        }}
      >
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>
    );
  }

  return (
    <div
      style={{
        height: '100%',
        overflow: 'auto',
      }}
    >
      <pre
        style={{
          margin: 0,
          fontSize: '13px',
          lineHeight: '1.4',
          fontFamily: 'Monaco, Menlo, "Ubuntu Mono", monospace',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
        }}
      >
        {content}
      </pre>
    </div>
  );
};
